import React from "react";
import { DualIcon } from "../../../../../components";

const DualIconList = () => {
  return (
    <div className="flex flex-col gap-5 m-4">
      <div className="flex gap-10">
        <DualIcon size="xs" iconColor="warning" badgeIconColor="bg-success" />
        <DualIcon size="sm" iconColor="warning" badgeIconColor="bg-success" />
        <DualIcon size="md" iconColor="warning" badgeIconColor="bg-success" />
        <DualIcon size="lg" iconColor="warning" badgeIconColor="bg-success" />
        <DualIcon size="xl" iconColor="warning" badgeIconColor="bg-success" />
      </div>
      <div className="flex gap-10">
        <DualIcon
          size="xs"
          icon="article"
          badgeIcon={"visibility"}
          iconColor="info"
          dotPosition="bottom-right"
        />
        <DualIcon
          size="sm"
          icon="article"
          badgeIcon={"visibility"}
          iconColor="info"
          dotPosition="bottom-right"
        />
        <DualIcon
          size="md"
          icon="article"
          badgeIcon={"visibility"}
          iconColor="info"
          dotPosition="bottom-right"
        />
        <DualIcon
          size="lg"
          icon="article"
          badgeIcon={"visibility"}
          iconColor="info"
          dotPosition="bottom-right"
        />
        <DualIcon
          size="xl"
          icon="article"
          badgeIcon={"visibility"}
          iconColor="info"
          dotPosition="bottom-right"
        />
      </div>
    </div>
  );
};

export default DualIconList;
